import * as ng from 'angular';
import { AuthContextService, NavigationService } from '../../../../../../services';
import { OrganismOverviewController, OverviewDataObject } from '../../../../../organisms';

export class MoleculeOverviewRowPanelDomainJobController implements ng.IController {
    public static $inject: string[] = ['authContext', 'navigation'];

    public overviewData: OverviewDataObject;
    public OrganismOverview: OrganismOverviewController;
    public overviewLoad: (selection: any) => any;
    public internalPaginationLimit: number;

    constructor(
        private authContext: AuthContextService,
        private navigation: NavigationService
    ) {}

    public get showAccounts() {
        return this.OrganismOverview.globals.showAccounts;
    }

    public get showTriggeredBy() {
        return this.authContext.isRootOrCompanyAccount;
    }
}

export class MoleculeOverviewRowPanelDomainJobComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        internalPaginationLimit: '<',
        overviewData: '<',
        overviewLoad: '<'
    };
    public controller =  MoleculeOverviewRowPanelDomainJobController;
    public controllerAs = 'OverviewDomainJobCtrl';
    public template = require('./domain-job-row.html');
}
